/**
 * FlashcardsPage
 *
 * Renders a full-page FlashcardReviewSession for a specific domain.
 * Route: /flashcards/:domain
 */
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import FlashcardReviewSession from '../components/scenes/FlashcardReviewSession';
import LearnerNav from '../components/nav/LearnerNav';

const DOMAIN_LABELS = {
  ai_orchestrator: 'AI Orchestrator',
  ai_beginner: 'AI Beginner',
  ai_entrepreneur: 'AI Entrepreneur',
  football: 'Football IQ',
  lsat: 'LSAT Prep',
  sat: 'SAT Prep',
};

export default function FlashcardsPage() {
  const { domain } = useParams();
  const { user, learner } = useAuth();
  const navigate = useNavigate();

  // learner_id can come from either user or learner depending on AuthContext shape
  const learnerId = learner?.learner_id || user?.learner_id;
  const domainLabel = DOMAIN_LABELS[domain] || (domain || '').replace(/_/g, ' ');

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--bg-primary, #0a0e1a)',
        display: 'flex',
        flexDirection: 'column',
        padding: '0',
      }}
    >
      <LearnerNav />
      {/* Sub-bar: domain title + back */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          padding: '14px 20px',
          borderBottom: '1px solid rgba(255,255,255,0.08)',
          background: 'rgba(255,255,255,0.03)',
        }}
      >
        <button
          onClick={() => navigate('/dashboard')}
          style={{
            background: 'rgba(255,255,255,0.07)',
            border: '1px solid rgba(255,255,255,0.12)',
            color: '#94a3b8',
            borderRadius: 8,
            padding: '7px 14px',
            fontSize: 13,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 6,
          }}
        >
          ← Dashboard
        </button>
        <h2
          style={{
            margin: 0,
            fontSize: 16,
            fontWeight: 600,
            color: '#e2e8f0',
          }}
        >
          {domainLabel} — Flashcard Review
        </h2>
      </div>

      {/* Review session */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          padding: '32px 16px',
        }}
      >
        {learnerId ? (
          <div style={{ width: '100%', maxWidth: 680 }}>
            <FlashcardReviewSession
              learnerId={learnerId}
              domain={domain}
              onExit={() => navigate('/dashboard')}
            />
          </div>
        ) : (
          <div style={{ textAlign: 'center', color: '#94a3b8', padding: 60 }}>
            <div
              style={{
                width: 36,
                height: 36,
                border: '3px solid rgba(99,102,241,0.3)',
                borderTopColor: '#6366f1',
                borderRadius: '50%',
                animation: 'spin 0.8s linear infinite',
                margin: '0 auto 16px',
              }}
            />
            <p style={{ fontSize: 14 }}>Initializing session…</p>
          </div>
        )}
      </div>

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}
